"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

require("core-js/modules/es6.function.name.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTransitionGroup = require("react-transition-group");

var _currency = require("@nerdwallet/currency");

var _withLabelAndHelperMessageModule = _interopRequireDefault(require("./with-label-and-helper-message.module.css"));

var _excluded = ["className", "label", "error", "value", "fixedLabel"];
var messageTransitionStyle = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  }
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var withLabelAndHelperMessage = function withLabelAndHelperMessage(ComponentToWrap) {
  var propTypes = {
    className: _propTypes.default.string,
    label: _propTypes.default.string.isRequired,
    helpMessage: _propTypes.default.string,
    errorMessage: _propTypes.default.string,
    error: _propTypes.default.bool,
    onFocus: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    fixedLabel: _propTypes.default.bool
  };

  var WithLabelAndHelperMessage = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(WithLabelAndHelperMessage, _Component);

    var _super = (0, _createSuper2.default)(WithLabelAndHelperMessage);

    function WithLabelAndHelperMessage(props) {
      var _this;

      (0, _classCallCheck2.default)(this, WithLabelAndHelperMessage);
      _this = _super.call(this, props);
      _this.state = {
        isComponentFocused: false
      };
      _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2.default)(_this));
      _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(WithLabelAndHelperMessage, [{
      key: "onFocus",
      value: function onFocus(e) {
        this.setState({
          isComponentFocused: true
        });
        if (this.props.onFocus) this.props.onFocus(e);
      }
    }, {
      key: "onBlur",
      value: function onBlur(e) {
        this.setState({
          isComponentFocused: false
        });
        if (this.props.onBlur) this.props.onBlur(e);
      }
    }, {
      key: "renderHelpMessage",
      value: function renderHelpMessage() {
        var _this$props = this.props,
            helpMessage = _this$props.helpMessage,
            error = _this$props.error;
        var showHelpMessage = this.state.isComponentFocused && helpMessage && !error;
        return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, {
          mountOnEnter: true,
          unmountOnExit: true,
          in: showHelpMessage,
          timeout: showHelpMessage ? 0 : 400
        }, function (state) {
          return /*#__PURE__*/_react.default.createElement(_currency.Type, {
            size: 1,
            className: _withLabelAndHelperMessageModule.default['help-message'],
            style: (0, _objectSpread2.default)({}, messageTransitionStyle[state])
          }, helpMessage);
        });
      }
    }, {
      key: "renderErrorMessage",
      value: function renderErrorMessage() {
        var _this$props2 = this.props,
            errorMessage = _this$props2.errorMessage,
            error = _this$props2.error;
        var errorClasses = (0, _classnames.default)([_withLabelAndHelperMessageModule.default['help-message']], [_withLabelAndHelperMessageModule.default['error-message']]);
        var showErrorMessage = errorMessage && error;
        return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, {
          mountOnEnter: true,
          unmountOnExit: true,
          in: showErrorMessage,
          timeout: showErrorMessage ? 0 : 400
        }, function (state) {
          return /*#__PURE__*/_react.default.createElement(_currency.Type, {
            size: 1,
            className: errorClasses,
            style: messageTransitionStyle[state]
          }, errorMessage);
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _classNames;

        var isComponentFocused = this.state.isComponentFocused;
        var _this$props3 = this.props,
            classNameProp = _this$props3.className,
            label = _this$props3.label,
            error = _this$props3.error,
            value = _this$props3.value,
            fixedLabel = _this$props3.fixedLabel,
            otherProps = (0, _objectWithoutProperties2.default)(_this$props3, _excluded);
        var containerClasses = (0, _classnames.default)(classNameProp, [_withLabelAndHelperMessageModule.default.container]);
        var labelClasses = (0, _classnames.default)([_withLabelAndHelperMessageModule.default.label], (_classNames = {}, (0, _defineProperty2.default)(_classNames, _withLabelAndHelperMessageModule.default['label-dynamic'], !fixedLabel), (0, _defineProperty2.default)(_classNames, _withLabelAndHelperMessageModule.default['label-fixed'], fixedLabel), (0, _defineProperty2.default)(_classNames, _withLabelAndHelperMessageModule.default['label-green'], isComponentFocused), (0, _defineProperty2.default)(_classNames, _withLabelAndHelperMessageModule.default['label-float'], (isComponentFocused || value || value === 0) && !fixedLabel), (0, _defineProperty2.default)(_classNames, _withLabelAndHelperMessageModule.default['label-error'], error), _classNames));
        delete otherProps.helpMessage;
        delete otherProps.errorMessage;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: containerClasses
        }, /*#__PURE__*/_react.default.createElement(_currency.Type, {
          className: labelClasses
        }, label), /*#__PURE__*/_react.default.createElement(ComponentToWrap, (0, _extends2.default)({}, otherProps, {
          fixedLabel: fixedLabel,
          value: value,
          error: error,
          isComponentFocused: this.state.isComponentFocused,
          onFocus: this.onFocus,
          onBlur: this.onBlur
        })), this.renderHelpMessage(), this.renderErrorMessage());
      }
    }]);
    return WithLabelAndHelperMessage;
  }(_react.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


  WithLabelAndHelperMessage.displayName = "WithLabelAndHelperMessage(".concat(getDisplayName(ComponentToWrap), ")"); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

  WithLabelAndHelperMessage.propTypes = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, ComponentToWrap.propTypes), propTypes); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

  WithLabelAndHelperMessage.defaultProps = ComponentToWrap.defaultProps;
  return WithLabelAndHelperMessage;
};

var _default = withLabelAndHelperMessage;
exports.default = _default;